<template>
    <v-sheet class="pa-16">
        <v-text-field v-model="w" label="width" />
        {{ width }}
        <v-text-field v-model="h" label="height" class="mt-10" />
        {{ height }}
    </v-sheet>
</template>

<script>
    export default {
        data() {
            return {
                w: '',
                h: '',
                width: '',
                height: ''
            }
        },

        watch: {
            w(val) {
                if (val) {
                    this.width = Math.round(792 / 595 * val)
                } else {
                    this.width = ''
                }
            },
            h(val) {
                if (val) {
                    this.height = Math.round(1122 / 842 * val)
                } else {
                    this.height =''
                }
            },
        }
    }
</script>
